// Rotulo de cada acao da auditoria (tela de auditoria e atividade das contas).
export const ACTION_LABELS = {
  'login.password': 'Entrou com e-mail e senha',
  'login.code': 'Confirmou o código de acesso',
  logout: 'Saiu do painel',
  'admin.password.change': 'Trocou a própria senha',
  'admin.password.confirm': 'Confirmou a senha para uma ação',
  'admin.password.reset_request': 'Pediu link de nova senha',
  'admin.password.reset': 'Criou senha nova pelo link',
  'access.denied': 'Tentou ação sem permissão',
  'user.search': 'Buscou clientes',
  'user.list': 'Listou clientes',
  'user.view': 'Abriu cliente',
  'user.reveal_pii': 'Viu dados completos de cliente',
  'user.view_as': 'Abriu visualização como cliente',
  'user.view_as_end': 'Encerrou visualização como cliente',
  'user.reset_link': 'Enviou link de senha a cliente',
  'user.temp_password': 'Gerou senha provisória de cliente',
  'company.search': 'Buscou oficinas',
  'company.view': 'Abriu oficina',
  'company.reveal_pii': 'Viu e-mail completo de oficina',
  'company.reset_link': 'Enviou link de acesso a oficina',
  'company.temp_password': 'Gerou senha provisória de oficina',
  'vehicle.list': 'Listou veículos',
  'maintenance.search': 'Abriu histórico de placa',
  'maintenance.view': 'Abriu itens de atendimento',
  'maintenance.reveal_customer': 'Viu dados completos do cliente de atendimento',
  'audit.view': 'Consultou a auditoria',
  'admin.created_by_script': 'Admin criado no servidor',
  'admin.reset_by_script': 'Admin redefinido no servidor',
};

export const actionLabel = (action) => ACTION_LABELS[action] || action;
